import {setKeysFromPartial} from '..'
import {
  GetterConfigArgs
} from '../config/getterConfig'
import {buildConfig, applyConfig} from '../config/configBuilder'
import {reduce, isEmpty} from 'lodash'

export interface IConfigurable {
  config?: GetterConfigArgs
}

export function deenumerateConfig<T extends IConfigurable>(obj: T) {
  const currentConfig = obj.config
  Object.defineProperty(obj, 'config', {
    enumerable: false
  })
  obj.config = currentConfig
}

export function findConfig<T extends Transerializable>(obj: T): GetterConfigArgs {
  const config = (obj as IConfigurable).config
  return Object.assign({
    ignorePaths: [],
    optionalPartialConfig: {}
  }, config)
}

export const ID_KEY = '__@@_id_key'
let ID = 0

function deenumerateIDKey<T extends Transerializable>(obj: T) {
  const currentKey = obj[ID_KEY]
  Object.defineProperty(obj, ID_KEY, {
    enumerable: false
  })
  obj[ID_KEY] = currentKey
}

export class Transerializable {

  [ID_KEY] = ID++

  /* tslint:disable */
  static ConfigMap: object = {}
  /* tslint:enable */

  static build<T extends Transerializable>(
    this: { new (): T },
    arg: Partial<T & {json: object}> = {}
  ): T {
    const obj = new this()
    deenumerateIDKey(obj)
    const {json, ...fields} = arg as Partial<Object & {json: object}>
    const partial = setKeysFromPartial<T>(obj, fields as T)
    return Transerializable.parseJson2(partial as T, json)
  }

  static parseJson<T extends Transerializable>(
    this: { new (): T },
    json: object = {}
  ): T {
    const obj = new this()

    return Transerializable.parseJson2(obj, json)
  }

  static parseJson2<T extends Transerializable>(
    obj: T,
    json: object = {}
  ): T {
    deenumerateIDKey(obj)
    if (isEmpty(json)) {
      return obj
    }
    const { name } = obj.constructor
    if (!Transerializable.ConfigMap[name]) {
      const config = (this.prototype as IConfigurable).config
      const {
        ignorePaths,
        optionalPartialConfig
      } = (config) ? config : findConfig(obj)
      Transerializable.ConfigMap[name] =
        buildConfig(obj, json, ignorePaths, optionalPartialConfig)
    }
    return applyConfig(obj, Transerializable.ConfigMap[name], json) as T
  }

  toJSON(): Transerializable {
    const { config, [ID_KEY]: idKey, ...copy } = this as any
    return copy
  }
}

export function stripSpecialFields<T extends Transerializable>(obj: T): object {
  return reduce(Object.keys(obj), (acc: object, key: string) => {
    if (key !== 'config' && key !== 'constructor' && key !== ID_KEY) {
      acc[key] = obj[key]
    }
    return acc
  }, {})
}
